// ============================================================
// cf-grouptable.js � Reusable GroupTable helper
// Load hanya pada halaman yang menggunakan Grouping Table.
//
// Dependencies: site.js (CF.appConfig), jQuery, DataTables,
//               DataTables RowGroup plugin
//
// Auto-injects (tidak perlu ditulis di cshtml):
//   - table-toolbar-top  (search, columns toggle, filter btn,
//                         expand/collapse all, actions dropdown)
//   - filter-bar         (active filter chips)
//   - group-by-wrap      (group-by selector chips + group stats)
//   - row-ctx-menu       (row context menu)
//   - table-toolbar-bottom (page size, row info, pagination)
//
// Yang TETAP ditulis di cshtml:
//   - <table> dengan <thead> (nama kolom)
//   - filter modal body (#filter-body) � custom form fields
//
// Usage:
//   var gt = CF.groupTable.init('#myTable', {
//       data: [...],
//       columns: [...],           // DataTables column config
//       defaultGroupCol: 2,       // default group-by column index
//       groupOptions: [           // group-by selector chips
//           { col: 2, icon: 'fa-solid fa-sitemap', label: 'Department' },
//           { col: 3, icon: 'fa-solid fa-user-tag', label: 'Role' },
//       ],
//       groupSrcFn: function(colIdx) { return colIdx; },  // optional: map col ? dataSrc
//       groupLabelFn: function(colIdx, value) { return value; }, // optional: render group label
//       groupStatsFn: function(rows, colIdx) {            // optional: group summary badges
//           return '8 active � 73 projects';
//       },
//       actions: [...],
//       rowActions: [...],
//       onRowAction: function(action, rowData) { ... }
//   });
// ============================================================

window.CF = window.CF || {};

(function () {
    'use strict';

    var _groupCounter = 0;
    var _groupRegistry = {};

    // ????????????????????????????????????????????????????????
    // CF.groupTable
    // ????????????????????????????????????????????????????????
    CF.groupTable = (function () {

        // ?? Pagination helpers ??????????????????????????????
        function _pageRangeArr(cur, total) {
            if (total <= 7) return Array.from({ length: total }, function (_, i) { return i; });
            if (cur < 4)    return [0, 1, 2, 3, 4, '\u2026', total - 1];
            if (cur > total - 5) return [0, '\u2026', total - 5, total - 4, total - 3, total - 2, total - 1];
            return [0, '\u2026', cur - 1, cur, cur + 1, '\u2026', total - 1];
        }

        function _renderFooter(dtInstance, footerIds) {
            if (!dtInstance) return;

            var info         = dtInstance.page.info();
            var cur          = info.page;
            var total        = info.pages;
            var totalCount   = info.recordsDisplay;
            var start        = totalCount === 0 ? 0 : info.start + 1;
            var end          = info.end;

            var rowInfoEl = document.getElementById(footerIds.rowInfoId);
            if (rowInfoEl) {
                var filteredNote = info.recordsTotal !== totalCount
                    ? ' (filtered from ' + info.recordsTotal + ')' : '';
                rowInfoEl.textContent = 'Showing ' + start + '\u2013' + end +
                    ' of ' + totalCount + ' entries' + filteredNote;
            }

            var wrap = document.getElementById(footerIds.paginationWrapId);
            if (!wrap) return;

            var uid  = footerIds._uid;
            var btns = '';
            btns += '<button class="pg-btn' + (cur === 0 ? ' disabled' : '') +
                '" onclick="CF.groupTable._goPage(' + uid + ',0)" title="First"><i class="fa-solid fa-angles-left"></i></button>';
            btns += '<button class="pg-btn' + (cur === 0 ? ' disabled' : '') +
                '" onclick="CF.groupTable._goPage(' + uid + ',' + (cur - 1) + ')" title="Prev"><i class="fa-solid fa-angle-left"></i></button>';

            _pageRangeArr(cur, total).forEach(function (p) {
                if (p === '\u2026') { btns += '<button class="pg-btn ellipsis">\u2026</button>'; return; }
                btns += '<button class="pg-btn' + (p === cur ? ' active' : '') +
                    '" onclick="CF.groupTable._goPage(' + uid + ',' + p + ')">' + (p + 1) + '</button>';
            });

            btns += '<button class="pg-btn' + (cur >= total - 1 || total === 0 ? ' disabled' : '') +
                '" onclick="CF.groupTable._goPage(' + uid + ',' + (cur + 1) + ')" title="Next"><i class="fa-solid fa-angle-right"></i></button>';
            btns += '<button class="pg-btn' + (cur >= total - 1 || total === 0 ? ' disabled' : '') +
                '" onclick="CF.groupTable._goPage(' + uid + ',' + (total - 1) + ')" title="Last"><i class="fa-solid fa-angles-right"></i></button>';

            wrap.innerHTML = btns;
        }

        function _buildPageSizeSelect(selectId, currentSize) {
            var el = document.getElementById(selectId);
            if (!el) return;
            var options = CF.appConfig.pagination.pageSizeOptions;
            el.innerHTML = '';
            options.forEach(function (size) {
                var opt = document.createElement('option');
                opt.value       = size;
                opt.textContent = size;
                if (size === currentSize) opt.selected = true;
                el.appendChild(opt);
            });
        }

        // ?? Inject toolbar top ??????????????????????????????
        function _injectToolbarTop(card, uid, columns, actions) {
            if (card.querySelector('.table-toolbar-top')) return;

            var colPopupId = 'gt-col-popup-' + uid;
            var actPopupId = 'gt-act-popup-' + uid;
            var searchId   = 'gt-search-'    + uid;

            // Column toggle items (skip columns without title)
            var colItems = '';
            columns.forEach(function (col, i) {
                if (!col.title) return;
                colItems += '<label class="col-toggle-item">' +
                    '<input type="checkbox" checked onchange="CF.groupTable._toggleColumn(' + uid + ',' + i + ',this.checked)" />' +
                    col.title +
                '</label>';
            });

            // Actions dropdown items
            var actItems = '';
            if (actions && actions.length) {
                actions.forEach(function (a, idx) {
                    if (a.divider) {
                        actItems += '<div class="pm-divider"></div>';
                    } else {
                        actItems += '<div class="pm-item' + (a.danger ? ' danger' : '') + '"' +
                            ' onclick="CF.groupTable._onAction(' + uid + ',' + idx + ')">' +
                            '<span class="pm-icon"><i class="' + (a.icon || '') + '"></i></span>' +
                            a.label +
                        '</div>';
                    }
                });
            }

            var hasActions = actions && actions.some(function (a) { return !a.divider; });
            var actionsBtn = '';
            if (hasActions) {
                actionsBtn =
                    '<div style="position:relative">' +
                        '<button class="tb-btn tb-btn-primary" onclick="togglePopup(\'' + actPopupId + '\')">' +
                            'Actions <i class="fa-solid fa-chevron-down" style="font-size:9px;margin-left:2px"></i>' +
                        '</button>' +
                        '<div id="' + actPopupId + '" class="actions-popup popup-menu">' +
                            actItems +
                        '</div>' +
                    '</div>';
            }

            var html =
                '<div class="table-toolbar-top">' +
                    '<div class="toolbar-search">' +
                        '<i class="fa-solid fa-magnifying-glass"></i>' +
                        '<input type="text" id="' + searchId + '" placeholder="Search all columns\u2026"' +
                            ' oninput="CF.groupTable._onSearch(' + uid + ',this.value)" />' +
                    '</div>' +
                    '<div class="toolbar-actions">' +
                        '<div style="position:relative">' +
                            '<button class="tb-btn" onclick="togglePopup(\'' + colPopupId + '\')">' +
                                '<i class="fa-solid fa-table-columns"></i> Columns' +
                            '</button>' +
                            '<div id="' + colPopupId + '" class="col-toggle-popup popup-menu">' +
                                colItems +
                            '</div>' +
                        '</div>' +
                        '<button class="tb-btn" id="gt-filter-btn-' + uid + '" onclick="openFilterModal()">' +
                            '<i class="fa-solid fa-sliders"></i> Filter' +
                            '<span class="filter-badge" id="filter-badge">0</span>' +
                        '</button>' +
                        '<button class="tb-btn" onclick="CF.groupTable._expandAll(' + uid + ')" title="Expand All">' +
                            '<i class="fa-solid fa-angles-down"></i> Expand All' +
                        '</button>' +
                        '<button class="tb-btn" onclick="CF.groupTable._collapseAll(' + uid + ')" title="Collapse All">' +
                            '<i class="fa-solid fa-angles-up"></i> Collapse All' +
                        '</button>' +
                        actionsBtn +
                    '</div>' +
                '</div>';

            card.insertAdjacentHTML('afterbegin', html);
        }

        // ?? Inject filter bar ???????????????????????????????
        function _injectFilterBar(card) {
            if (card.querySelector('#filter-bar')) return;
            var toolbar = card.querySelector('.table-toolbar-top');
            if (toolbar) {
                toolbar.insertAdjacentHTML('afterend', '<div id="filter-bar"></div>');
            }
        }

        // ?? Inject group-by bar ?????????????????????????????
        function _injectGroupByBar(card, uid, groupOptions, currentGroupCol) {
            if (card.querySelector('.group-by-wrap')) return;

            var chipsHtml = '';
            (groupOptions || []).forEach(function (opt) {
                var active = opt.col === currentGroupCol ? ' active' : '';
                chipsHtml +=
                    '<button class="group-by-chip' + active + '" data-col="' + opt.col + '"' +
                        ' onclick="CF.groupTable._setGroupBy(' + uid + ',' + opt.col + ')">' +
                        '<i class="' + opt.icon + '"></i>' +
                        '<span>' + opt.label + '</span>' +
                    '</button>';
            });

            var html =
                '<div class="group-by-wrap" id="gt-group-by-wrap-' + uid + '">' +
                    '<span class="group-by-label">' +
                        '<i class="fa-solid fa-object-group"></i> Group by:' +
                    '</span>' +
                    '<div class="group-by-options" id="gt-group-by-options-' + uid + '">' +
                        chipsHtml +
                    '</div>' +
                    '<span id="gt-group-stats-' + uid + '" class="group-by-stats"></span>' +
                '</div>';

            var filterBar = card.querySelector('#filter-bar');
            var target    = filterBar || card.querySelector('.table-toolbar-top');
            if (target) target.insertAdjacentHTML('afterend', html);
        }

        // ?? Inject row context menu ?????????????????????????
        function _injectRowContextMenu(uid, rowActions) {
            if (!rowActions || !rowActions.length) return;

            var existingMenu = document.getElementById('row-ctx-menu');
            if (existingMenu) existingMenu.remove();

            var items = '';
            rowActions.forEach(function (ra, idx) {
                if (ra.divider) {
                    items += '<div class="pm-divider"></div>';
                } else {
                    items +=
                        '<div class="pm-item' + (ra.danger ? ' danger' : '') + '"' +
                            ' onclick="CF.groupTable._onRowAction(' + uid + ',\'' + ra.action + '\')">' +
                            '<span class="pm-icon"><i class="' + (ra.icon || '') + '"></i></span>' +
                            ra.label +
                        '</div>';
                }
            });

            document.body.insertAdjacentHTML('beforeend',
                '<div id="row-ctx-menu">' + items + '</div>');
        }

        // ?? Inject toolbar bottom ???????????????????????????
        function _injectToolbarBottom(card, uid, defaultLen) {
            if (card.querySelector('.table-toolbar-bottom')) return null;

            var pageSizeId   = 'gt-page-size-'  + uid;
            var rowInfoId    = 'gt-row-info-'    + uid;
            var paginationId = 'gt-pagination-'  + uid;

            var options     = CF.appConfig.pagination.pageSizeOptions;
            var optionsHtml = options.map(function (s) {
                return '<option value="' + s + '"' + (s === defaultLen ? ' selected' : '') + '>' + s + '</option>';
            }).join('');

            var html =
                '<div class="table-toolbar-bottom">' +
                    '<div class="toolbar-row-info">' +
                        '<div class="page-size-wrap">' +
                            'Show ' +
                            '<select class="page-size-select" id="' + pageSizeId + '"' +
                                ' onchange="CF.groupTable._onPageSizeChange(' + uid + ',this.value)">' +
                                optionsHtml +
                            '</select>' +
                            ' entries' +
                        '</div>' +
                        '<span id="' + rowInfoId + '"></span>' +
                    '</div>' +
                    '<div class="toolbar-pagination" id="' + paginationId + '"></div>' +
                '</div>';

            var tableWrap = card.querySelector('.table-wrap');
            if (tableWrap) tableWrap.insertAdjacentHTML('afterend', html);
            else           card.insertAdjacentHTML('beforeend', html);

            return {
                _uid:             uid,
                paginationWrapId: paginationId,
                rowInfoId:        rowInfoId,
                pageSizeSelectId: pageSizeId
            };
        }

        // ?? Inject filter modal shell ???????????????????????
        function _injectFilterModalShell() {
            if (document.getElementById('modal-overlay')) return;
            var filterBody = document.getElementById('filter-body');
            if (!filterBody) return;

            var bodyContent = filterBody.innerHTML;
            filterBody.remove();

            var html =
                '<div id="modal-overlay" onclick="onOverlayClick(event)">' +
                    '<div class="modal-box">' +
                        '<div class="modal-header">' +
                            '<div class="modal-header-title">' +
                                '<i class="fa-solid fa-sliders"></i> Advanced Filter' +
                            '</div>' +
                            '<button class="modal-close" onclick="closeFilterModal()">' +
                                '<i class="fa-solid fa-xmark"></i>' +
                            '</button>' +
                        '</div>' +
                        '<div class="modal-body">' + bodyContent + '</div>' +
                        '<div class="modal-footer">' +
                            '<button onclick="resetAllFilters(true)" class="tb-btn" style="color:#EF4444">' +
                                '<i class="fa-solid fa-rotate-left"></i> Reset All' +
                            '</button>' +
                            '<div style="display:flex;gap:8px;margin-left:auto">' +
                                '<button onclick="closeFilterModal()" class="tb-btn">Cancel</button>' +
                                '<button onclick="applyFilters()" class="tb-btn tb-btn-primary">' +
                                    '<i class="fa-solid fa-check"></i> Apply Filter' +
                                '</button>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>';

            document.body.insertAdjacentHTML('beforeend', html);
        }

        // ?? Apply column min-widths ?????????????????????????
        function _applyColumnWidths(dtInstance, columns) {
            if (!dtInstance || !columns) return;
            var headerCells = dtInstance.table().node().querySelectorAll('thead th');
            var totalMinPx  = 0;
            columns.forEach(function (col, i) {
                var mw = parseInt(col.minWidth, 10);
                if (mw > 0) {
                    totalMinPx += mw;
                    if (headerCells[i]) headerCells[i].style.minWidth = col.minWidth;
                }
            });
            if (totalMinPx > 0) dtInstance.table().node().style.minWidth = totalMinPx + 'px';
        }

        // ?? Auto-resize observer ????????????????????????????
        function _attachResizeObserver(dtInstance) {
            var timer = null;
            function adjust() {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    if (dtInstance) dtInstance.columns.adjust();
                }, 80);
            }
            var mainWrapper = document.querySelector('.main-wrapper');
            if (mainWrapper && typeof ResizeObserver !== 'undefined') {
                new ResizeObserver(adjust).observe(mainWrapper);
            }
            window.addEventListener('resize', adjust);
        }

        // ?? Build rowGroup config ???????????????????????????
        function _buildRowGroupConfig(ctx) {
            var uid      = ctx.uid;
            var opts     = ctx.opts;
            var colIdx   = ctx.currentGroupCol;
            var dataSrc  = typeof opts.groupSrcFn === 'function'
                ? opts.groupSrcFn(colIdx) : colIdx;

            return {
                dataSrc:      dataSrc,
                startRender:  function (rows, group) {
                    // Aggregate stats
                    var statsHtml = '';
                    if (typeof opts.groupStatsFn === 'function') {
                        statsHtml = opts.groupStatsFn(rows, colIdx);
                    }

                    // Group label
                    var labelHtml = typeof opts.groupLabelFn === 'function'
                        ? opts.groupLabelFn(colIdx, group)
                        : group;

                    var colCount = (opts.columns || []).length;
                    var isCollapsed = !!ctx.collapsedGroups[group];
                    var chevronCls  = isCollapsed ? 'fa-chevron-right' : 'fa-chevron-down';
                    var toggleCls   = isCollapsed ? ' collapsed' : '';

                    return $('<tr/>')
                        .addClass('dtrg-group')
                        .attr('data-group', group)
                        .html(
                            '<td colspan="' + colCount + '">' +
                                '<div class="group-row-inner">' +
                                    '<span class="group-toggle-icon' + toggleCls + '">' +
                                        '<i class="fa-solid ' + chevronCls + '" style="font-size:10px"></i>' +
                                    '</span>' +
                                    '<span class="group-label-text">' + labelHtml + '</span>' +
                                    '<span class="group-count-badge">' + rows.count() + '</span>' +
                                    (statsHtml
                                        ? '<span class="group-sum-badge">' + statsHtml + '</span>'
                                        : '') +
                                '</div>' +
                            '</td>'
                        );
                }
            };
        }

        // ?? Collapse / expand state helpers ?????????????????
        function _applyCollapsedState(ctx) {
            var isCollapsed = false;

            $('#' + ctx.tableId + ' tbody tr').each(function () {
                if ($(this).hasClass('dtrg-group')) {
                    var group = $(this).attr('data-group');
                    isCollapsed = !!ctx.collapsedGroups[group];

                    var icon     = $(this).find('.group-toggle-icon i');
                    var toggleEl = $(this).find('.group-toggle-icon');

                    if (isCollapsed) {
                        icon.removeClass('fa-chevron-down').addClass('fa-chevron-right');
                        toggleEl.addClass('collapsed');
                    } else {
                        icon.removeClass('fa-chevron-right').addClass('fa-chevron-down');
                        toggleEl.removeClass('collapsed');
                    }
                } else if (!$(this).hasClass('dtrg-group')) {
                    if (isCollapsed) $(this).addClass('group-row-hidden');
                    else             $(this).removeClass('group-row-hidden');
                }
            });
        }

        // Use event delegation on tbody � RowGroup re-inserts .dtrg-group rows
        // after drawCallback fires, so direct .on() binding would miss them.
        function _attachGroupClickHandlers(ctx) {
            var $tbody = $('#' + ctx.tableId + ' tbody');

            // Remove previous delegated handler then re-attach
            $tbody.off('click.gt', 'tr.dtrg-group').on('click.gt', 'tr.dtrg-group', function () {
                var group = $(this).attr('data-group');
                if (!group) return;

                if (ctx.collapsedGroups[group]) {
                    delete ctx.collapsedGroups[group];
                } else {
                    ctx.collapsedGroups[group] = true;
                }

                _applyCollapsedState(ctx);
            });
        }

        // ?? Update group-by chips ???????????????????????????
        function _updateGroupByChips(uid) {
            var ctx = _groupRegistry[uid];
            if (!ctx) return;
            document.querySelectorAll('#gt-group-by-options-' + uid + ' .group-by-chip')
                .forEach(function (c) {
                    var col = parseInt(c.getAttribute('data-col'), 10);
                    if (col === ctx.currentGroupCol) c.classList.add('active');
                    else                              c.classList.remove('active');
                });
        }

        // ?? Update group stats counter ??????????????????????
        function _updateGroupStats(uid) {
            var ctx = _groupRegistry[uid];
            if (!ctx || !ctx.dtInstance) return;

            var groups = {};
            $('#' + ctx.tableId + ' tbody tr.dtrg-group').each(function () {
                var g = $(this).attr('data-group');
                if (g) groups[g] = true;
            });

            var count = Object.keys(groups).length;
            var el = document.getElementById('gt-group-stats-' + uid);
            if (el) el.textContent = count + ' group' + (count !== 1 ? 's' : '');
        }

        // ?? Destroy & re-init DataTables instance ???????????
        function _reinit(uid) {
            var ctx = _groupRegistry[uid];
            if (!ctx) return;

            if (ctx.dtInstance) {
                ctx.dtInstance.destroy();
                ctx.dtInstance = null;
            }

            ctx.collapsedGroups = {};
            _doInit(uid);

            _updateGroupByChips(uid);
            _updateGroupStats(uid);
        }

        // ?? Core DataTables init ????????????????????????????
        function _doInit(uid) {
            var ctx          = _groupRegistry[uid];
            var opts         = ctx.opts;
            var callerDrawCb = opts.drawCallback;

            var merged = $.extend({
                pageLength: ctx.defaultLen,
                paging:     true,
                searching:  true,
                info:       true,
                dom:        'lrtip',
                autoWidth:  false
            }, _dtClean(opts), {
                order:    [[ctx.currentGroupCol, 'asc']],
                rowGroup: _buildRowGroupConfig(ctx),
                drawCallback: function () {
                    // RowGroup inserts .dtrg-group <tr> elements *after* drawCallback
                    // runs synchronously. Defer our DOM work by one tick so the group
                    // rows are already in the DOM when we query them.
                    var self = this;
                    setTimeout(function () {
                        _applyCollapsedState(ctx);
                        _attachGroupClickHandlers(ctx);
                        _updateGroupStats(uid);
                    }, 0);

                    _renderFooter(ctx.dtInstance, ctx.footerIds);

                    if (typeof callerDrawCb === 'function') {
                        callerDrawCb.call(self);
                    }
                }
            });

            ctx.dtInstance = $('#' + ctx.tableId).DataTable(merged);
        }

        // Strip custom props that DataTables doesn't understand
        function _dtClean(opts) {
            var clean = $.extend({}, opts);
            var removeKeys = [
                'actions', 'rowActions', 'onRowAction',
                'defaultGroupCol', 'groupOptions', 'groupSrcFn',
                'groupLabelFn', 'groupStatsFn', 'drawCallback'
            ];
            removeKeys.forEach(function (k) { delete clean[k]; });
            return clean;
        }

        // ?? Inject skeleton tbody rows ??????????????????????
        // Replaced by CF.skeleton.table() � see cf-skeleton.js.
        function _injectSkeletonRows(tableEl) {
            var tbody = tableEl.querySelector('tbody');
            if (tbody) CF.skeleton.table(tbody);
        }

        // ?? Main init ???????????????????????????????????????
        function init(selector, opts) {
            var tableEl = document.querySelector(selector);
            if (!tableEl) return null;

            var card = tableEl.closest('.table-card');
            if (!card) return null;

            // ?? Pre-fill tbody with skeleton rows ???????????
            _injectSkeletonRows(tableEl);

            // Derive stable table ID
            var tableId = tableEl.id;
            if (!tableId) {
                tableId = 'gt-table-' + (++_groupCounter);
                tableEl.id = tableId;
            } else {
                _groupCounter++;
            }

            var uid        = _groupCounter;
            var defaultLen = opts.pageLength || CF.appConfig.pagination.defaultPageSize;

            var ctx = {
                uid:               uid,
                tableId:           tableId,
                opts:              opts,
                dtInstance:        null,
                defaultLen:        defaultLen,
                currentGroupCol:   opts.defaultGroupCol || 0,
                collapsedGroups:   {},
                footerIds:         null
            };

            _groupRegistry[uid] = ctx;

            // ?? Inject all chrome ???????????????????????????
            _injectToolbarTop(card, uid, opts.columns || [], opts.actions);
            _injectFilterBar(card);
            _injectGroupByBar(card, uid, opts.groupOptions, ctx.currentGroupCol);
            _injectRowContextMenu(uid, opts.rowActions);
            _injectFilterModalShell();

            ctx.footerIds = _injectToolbarBottom(card, uid, defaultLen);
            if (!ctx.footerIds) {
                ctx.footerIds = { _uid: uid, paginationWrapId: '', rowInfoId: '', pageSizeSelectId: '' };
            }

            // ?? Init DataTables after one paint cycle (skeleton visible first)
            requestAnimationFrame(function () {
                setTimeout(function () {
                    _doInit(uid);

                    if (ctx.footerIds.pageSizeSelectId) {
                        _buildPageSizeSelect(ctx.footerIds.pageSizeSelectId, defaultLen);
                    }
                    _applyColumnWidths(ctx.dtInstance, opts.columns);
                    _attachResizeObserver(ctx.dtInstance);

                    _updateGroupByChips(uid);
                    _updateGroupStats(uid);
                }, 300);
            });

            return { uid: uid, instance: function () { return ctx.dtInstance; } };
        }

        // ?? Public: set group-by ????????????????????????????
        function _setGroupBy(uid, colIdx) {
            var ctx = _groupRegistry[uid];
            if (!ctx || ctx.currentGroupCol === colIdx) return;
            ctx.currentGroupCol = colIdx;
            _reinit(uid);
        }

        // ?? Public: expand all groups ???????????????????????
        function _expandAll(uid) {
            var ctx = _groupRegistry[uid];
            if (!ctx) return;
            ctx.collapsedGroups = {};
            _applyCollapsedState(ctx);
        }

        // ?? Public: collapse all groups ????????????????????
        function _collapseAll(uid) {
            var ctx = _groupRegistry[uid];
            if (!ctx) return;

            // Collect all currently-visible group names from DOM
            $('#' + ctx.tableId + ' tbody tr.dtrg-group').each(function () {
                var group = $(this).attr('data-group');
                if (group) ctx.collapsedGroups[group] = true;
            });

            _applyCollapsedState(ctx);
        }

        // ?? Internal callbacks (called from injected HTML) ??
        function _goPage(uid, p) {
            var ctx = _groupRegistry[uid];
            if (!ctx || !ctx.dtInstance) return;
            var info = ctx.dtInstance.page.info();
            if (p < 0 || p >= info.pages) return;
            ctx.collapsedGroups = {};
            ctx.dtInstance.page(p).draw('page');
        }

        function _onPageSizeChange(uid, val) {
            var ctx = _groupRegistry[uid];
            if (!ctx || !ctx.dtInstance) return;
            ctx.collapsedGroups = {};
            ctx.dtInstance.page.len(parseInt(val, 10)).draw();
        }

        function _onSearch(uid, val) {
            var ctx = _groupRegistry[uid];
            if (!ctx || !ctx.dtInstance) return;
            var q = val.trim();
            // Minimum 3 characters to trigger search, or empty to reset
            if (q.length > 0 && q.length < 3) return;
            ctx.collapsedGroups = {};
            ctx.dtInstance.search(q).draw();
        }

        function _toggleColumn(uid, idx, visible) {
            var ctx = _groupRegistry[uid];
            if (!ctx || !ctx.dtInstance) return;
            ctx.dtInstance.column(idx).visible(visible);
        }

        function _onAction(uid, idx) {
            var ctx = _groupRegistry[uid];
            if (!ctx) return;
            var action = (ctx.opts.actions || [])[idx];
            if (action && typeof action.onClick === 'function') action.onClick();
            document.querySelectorAll('.popup-menu.open').forEach(function (p) { p.classList.remove('open'); });
        }

        function _onRowAction(uid, action) {
            var ctx = _groupRegistry[uid];
            if (!ctx) return;

            var rowData = null;
            if (ctx._lastClickedBtn && ctx.dtInstance) {
                var row = $(ctx._lastClickedBtn).closest('tr');
                if (row.length) rowData = ctx.dtInstance.row(row).data();
            }

            if (typeof ctx.opts.onRowAction === 'function') {
                ctx.opts.onRowAction(action, rowData);
            }

            closeRowMenu();
        }

        // ?? Public API ??????????????????????????????????????
        return {
            init:               init,
            _setGroupBy:        _setGroupBy,
            _expandAll:         _expandAll,
            _collapseAll:       _collapseAll,
            _goPage:            _goPage,
            _onPageSizeChange:  _onPageSizeChange,
            _onSearch:          _onSearch,
            _toggleColumn:      _toggleColumn,
            _onAction:          _onAction,
            _onRowAction:       _onRowAction
        };
    })();

    // ????????????????????????????????????????????????????????
    // Row Context Menu � openRowMenu / closeRowMenu
    // Stores last clicked button ref for row data extraction
    // ????????????????????????????????????????????????????????
    var _origOpenRowMenu = window.openRowMenu;

    window.openRowMenu = function (e, btn) {
        e.stopPropagation();

        // Store btn ref in all registered grouptable contexts
        for (var uid in _groupRegistry) {
            if (Object.prototype.hasOwnProperty.call(_groupRegistry, uid)) {
                _groupRegistry[uid]._lastClickedBtn = btn;
            }
        }

        // If cf-datatable.js or cf-treetable.js already defined openRowMenu, call it
        if (typeof _origOpenRowMenu === 'function') {
            _origOpenRowMenu(e, btn);
            return;
        }

        var menu = document.getElementById('row-ctx-menu');
        if (!menu) return;

        var rect  = btn.getBoundingClientRect();
        var mh    = 160, mw = 190;
        var openUp = rect.bottom + mh > window.innerHeight;
        menu.style.top  = (openUp ? rect.top - mh - 4 : rect.bottom + 4) + 'px';
        menu.style.left = Math.min(rect.right - mw, window.innerWidth - mw - 8) + 'px';
        menu.classList.add('show');
    };

    if (typeof window.closeRowMenu !== 'function') {
        window.closeRowMenu = function () {
            var menu = document.getElementById('row-ctx-menu');
            if (menu) menu.classList.remove('show');
        };
    }

})();
